import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'

import { getHolidays } from '../api/timeoffApi'
import { Holiday } from '../types'

export default function useHolidays(options?: SWRConfiguration) {
  return useSWR<Holiday[], Error>('holidays', getHolidays, options)
}
